import React, { useState, useEffect, useRef, createElement } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import logo from './logo.svg';
import copy from './images/svg/copy-v2.svg';
import close from './images/svg/close.svg';
import download from './images/svg/download.svg';
import appleMail from'./images/png/apple-mail.png';
import gmail from './images/png/gmail.png';
import outlook from './images/png/outlook.png';
import search from './images/svg/search.svg';
import './App.scss';
import TemplateOne from './Components/templateOne.js';
import Loader from "./Components/component_helpers/loader.js";
import Notify from 'simple-notify';
import 'simple-notify/dist/simple-notify.min.css';

function pushNotify(heading, message) {
  new Notify({
    status: 'success',
    title: heading,
    text: message,
    effect: 'slide',
    speed: 300,
    customClass: 'notification-sig',
    customIcon: null,
    showIcon: true,
    showCloseButton: true,
    autoclose: true,
    autotimeout: 4000,
    gap: 20,
    distance: 20,
    type: 1,
    position: 'right bottom',
  });
}

function App() {
  const [gmailInstuctions, setGmailInstructions] = useState('');
  const [outlookInstuctions, setOutlookInstructions] = useState('');
  const [appleInstuctions, setAppleInstructions] = useState('');
  const [popupOpen, setpopupOpen] = useState(false);
  const openGmailInstructions = (event) => {

    setGmailInstructions('<div class="icon-popup-wrap"><h5 class="min-heading">Gmail</h5><img src="https://okmg-digital-assets.s3.ap-southeast-2.amazonaws.com/mesig/gmail.png" style="width:25px;height:25px;padding:5px;border:1px solid #eee;" alt="gmail"></div><ol><li><span style="font-weight:bold;">1. </span>Open <a href="https://mail.google.com/mail/u/0/" target="_blank" rel="noreferrer" style="color:#000;font-weight:bold;font-style:italic;">Gmail</a>.</li><li><span style="font-weight:bold;">2. </span>At the top right, click <span style="font-weight:bold;font-style:italic;">Settings</span> and then <span style="font-weight:bold;font-style:italic">See all settings</span>.</li><li><span style="font-weight:bold;">3. </span>In the "<span style="font-weight:bold;font-style:italic">Signature</span>" section, paste your signature from <a href="https://mesig.io" style="color:#000;font-style:italic;font-weight:bold;" target="_blank" rel="noreferer">mesig.io</a> into the text box.</li><li><span style="font-weight:bold;">4. </span>At the bottom of the page, click <span style="font-weight:bold;font-style:italic;">Save Changes</span>.</li></ol>');
    setpopupOpen(true);
  }
  const openOutlookInstructions = (event) => {

    setGmailInstructions('<div class="icon-popup-wrap"><h5 class="min-heading">Outlook</h5><img src="https://okmg-digital-assets.s3.ap-southeast-2.amazonaws.com/mesig/outlook.png" style="width:25px;height:25px;padding:5px;border:1px solid #eee;" alt="outlook"></div><ol><li><span style="font-weight:bold;">1. </span>Go to <span style="font-weight:bold;font-style:italic;">Settings > Compose and reply.</span></li><li><span style="font-weight:bold;">2. </span>Under <span style="font-weight:bold;font-style:italic;">Email signature</span>, paste your signature from <a href="https://mesig.io" target="_blank" rel="noreferrer" style="color:#000;font-weight:bold;font-style:italic;">mesig.io</a>.</li><li><span style="font-weight:bold;">3. </span>Select, <span style="font-weight:bold;font-style:italic;">Save</span> when you\'re done.</li></ol>');
    setpopupOpen(true);
  }
   const openAppleInstructions = (event) => {

    setGmailInstructions('<div class="icon-popup-wrap"><h5 class="min-heading">Apple Mail</h5><img src="https://okmg-digital-assets.s3.ap-southeast-2.amazonaws.com/mesig/apple-mail.png" style="width:25px;height:25px;padding:5px;border:1px solid #eee;" alt="apple mail"></div><ol><li><span style="font-weight:bold;">1. </span>In the Mail app on your mac, choose <span style="font-weight:bold;font-style:italic;">Mail > Settings</span>, then click <span style="font-weight:bold;font-style:italic;">Signatures</span></li><li><span style="font-weight:bold;">2. </span>In the left column (account list), select the email account where you want to use the signature.</li><li><span style="font-weight:bold;">3. </span>Click the Add button <span style="font-weight:bold;">+</span> below the middle column..</li><li><span style="font-weight:bold;">4. </span> In the middle column (signature list), type a name for your signature.</li><li><span style="font-weight:bold">5. </span>In the right column (<span style="font-weight:bold;">the preview</spa>) - paste your signature from <a href="https://mesig.io" target="_blank" rel="noreferrer" style="font-weight:bold;color:#000;font-style:italic;">mesig.io</a></li><li><span style="font-weight:bold;">6. </span>Click <span style="font-weight:bold;font-style:italic;">Save signature</span></li></ol>');
    setpopupOpen(true);
  }

  const closeInstructModal = (event) => {
    setpopupOpen(false);
  }
  return (
   <div className="app-wrap">
   <div className="navigation">
          <header>
            
           <h1 style={{ textTransform: 'capitalize' }}>Welcome</h1>
          </header>
          <section>
            <h5 className="mini-heading">Overview</h5>
            <ul>
              <li>Fill in the form to create an email signature.</li>
              <li>
                Copy the signature{' '}
                <img src={copy} style={{ height: '20px', position: 'relative', top: '2.5px', marginRight: '15px' }} />
              </li>
              <li>
                Download the signatures{' '}
                <img src={download} style={{ height: '20px', position: 'relative', top: '2.5px', marginRight: '15px' }} />
              </li>
              <li>
                Click the{' '}
                <strong>
                  <em>`Save`</em>
                </strong>{' '}
                button to save your signature.
              </li>
            </ul>
            <div className={`popup-instructions ${popupOpen ? "open-pop" : "close-pop"}`}>
                <img src={close} alt="x" className="close" style={{width:'25px',height:'25px',cursor:'pointer',position:'absolute',top:'15px',right:'15px'}} onClick={closeInstructModal}/>
                <div className="mail-instruct">
                {gmailInstuctions ? 
                <div
                  dangerouslySetInnerHTML={{ __html: gmailInstuctions }}
                />
                 : 

                ""}
                </div>
            </div>
            <div className="installation-instructions">
              <h5 className="mini-heading">Installation instructions</h5>
              <div className="icon-wrapper" style={{display:'flex',alignItems:'center',justifyContent: 'center', width:'100%'}}>
                <div>
                  <img src={gmail} alt="Gmail" style={{width:'25px',height:'25px',margin:'0 5px', padding: '5px'}} onClick={openGmailInstructions}/>
                </div>
                <div>
                  <img src={outlook} alt="outlook" style={{width:'25px',height:'25px',margin:'0 5px', padding: '5px'}} onClick={openOutlookInstructions}/>
                </div>
                  <div>
                  <img src={appleMail} alt="apple mail" style={{width:'25px',height:'25px',margin:'0 5px', padding: '5px'}} onClick={openAppleInstructions}/>
                </div>
              </div>
            </div>
            <a href="https://mesig.io" className="add-another" style={{marginTop:'15px',display:'inline-block',textDecoration:'none'}}>Back</a>
          </section>

        </div>
     <TemplateOne/>
     <div className="link-wrapper navigation">
          <section className="links" style={{ marginTop: '0' }}>
            <h5 className="mini-heading">Saved Signatures</h5>
            <h2 style={{ marginBottom: '25px' }}>Your Signatures</h2>
            <div className="search-wrapper">
              <input type="search"  placeholder="Filter signatures.." />
              <img src={search} className="icon" />
            </div>
            <h5 className="mini-heading">x Results</h5>

            <div className="saved-signatures-wrapper" >
          
                <div>
                  <ul>
                    <li>No signatures..</li>
                  </ul>
                </div>
            
            </div>
          </section>
        </div>
    </div>
  );
}

export default App;
